/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import * as types from "./types";
import Flowit from "../../../services/flowit";

export const state = {
  balance: 0,
  anticipationRule: null,
  anticipationTax: null,
  anticipationsAvailable: [],
  anticipationsAvailableCount: 0,
  currentTax: 0,
  selectedAnticipations: [],
  selectedAnticipationsAmount: 0,
  anticipationsAvailableLimit: 25,
  anticipationsAvailablePage: 1,
  loading: false,
  automaticAnticipationEnabled: false,
  anticipationRequestPending: false
};

export const mutations = {
  addAnticipation(state, anticipation) {
    state.selectedAnticipations.push(anticipation);
  },
  removeAnticipation(state, anticipation) {
    const filtered = state.selectedAnticipations.filter(item => item !== anticipation);
    state.selectedAnticipations = filtered;
  },
  loadMoreAnticipations(state) {
    state.anticipationsAvailablePage += 1;
    const params = {
      page: state.anticipationsAvailablePage
    };
    Flowit.account.anticipationsAvailable(params).then(response => {
      const newResources = response.data.resources;
      const resources = state.anticipationsAvailable;

      Array.prototype.push.apply(resources, newResources);
      state.anticipationsAvailable = resources;
    });
  },

  [types.BALANCE](state, balance) {
    state.balance = balance;
  },
  [types.ANTICIPATION_RULE](state, rule) {
    state.anticipationRule = rule;
  },
  [types.ANTICIPATION_TAX](state, tax) {
    state.anticipationTax = tax;
  },
  [types.ANTICIPATIONS_AVAILABLE](state, anticipationsAvailable) {
    state.anticipationsAvailable = anticipationsAvailable;
  },
  [types.ANTICIPATIONS_AVAILABLE_COUNT](state, anticipationsAvailableCount) {
    state.anticipationsAvailableCount = anticipationsAvailableCount;
  },
  [types.CURRENT_TAX](state, currentTax) {
    state.currentTax = currentTax;
  },
  [types.SELECTED_ANTICIPATIONS](state, selectedAnticipations) {
    state.selectedAnticipations = selectedAnticipations;
  },
  [types.SELECTED_ANTICIPATIONS_AMOUNT](state, selectedAnticipationsAmount) {
    state.selectedAnticipationsAmount = selectedAnticipationsAmount;
  },
  [types.ANTICIPATIONS_AVAILABLE_LIMIT](state, anticipationsAvailableLimit) {
    state.anticipationsAvailableLimit = anticipationsAvailableLimit;
  },
  [types.ANTICIPATIONS_AVAILABLE_PAGE](state, anticipationsAvailablePage) {
    state.anticipationsAvailablePage = anticipationsAvailablePage;
  },
  [types.ANTICIPATIONS_AVAILABLE_LOADING](state, loading) {
    state.loading = loading;
  },
  [types.ANTICIPATION_REQUEST_PENDING](state, pending) {
    state.anticipationRequestPending = pending;
  },
  [types.AUTOMATIC_ANTICIPATION_ENABLED](state, enabled) {
    state.automaticAnticipationEnabled = enabled;
  }
};
